import React from 'react';
import {
  AIConversation,
  AIConversationDetail,
  AIConversationSearchType,
} from 'v2/models';
import AIConversationPane from 'v2/pages/DrmFeatures/AISearch/AIConversation/AIConversationPane';
import styles from 'v2/pages/DrmFeatures/AISearch/AISearchDetail/index.module.scss';
import { AISearchTypesDisplay } from 'v2/utils/AISearchUtils';
import restFactory from 'v2/utils/restFactory';
import { useQuery } from 'react-query';
import { aiConversationKeys } from 'v2/queries';
import classnames from 'classnames';

interface AISearchDetailProps {
  conversation?: AIConversation;
}

const AISearchDetail = ({ conversation }: AISearchDetailProps) => {
  const { data: conversationDetails } = useQuery(
    aiConversationKeys.detail(conversation?.id),
    async () => {
      const response = await restFactory.get<AIConversationDetail>(
        `/dj/api/v1/ai_conversation/${conversation?.id}/`
      );

      return response;
    },
    { cacheTime: 0 }
  );

  return (
    <div className={styles.container}>
      {conversationDetails && (
        <>
          <div className={styles.details}>
            <div>
              <h6>Search Name</h6>
              <div className={styles.section}>
                {conversationDetails.name}
                <div className={styles.shadow}></div>
              </div>
            </div>
            <div>
              <h6>Search Type</h6>
              {AISearchTypesDisplay[conversationDetails.search_type]}
            </div>
            {conversationDetails.custom_chat?.name && (
              <div>
                <h6>Preset</h6>
                {conversationDetails.custom_chat.name}
              </div>
            )}
            <div>
              <h6>Companies</h6>
              {conversationDetails.all_companies ? (
                'All Companies'
              ) : (
                <ul>
                  {conversationDetails.data_vendor_names?.map((name, ix) => (
                    <li key={ix}>{name}</li>
                  ))}
                </ul>
              )}
            </div>
            {conversationDetails.search_type ===
              AIConversationSearchType.DOCUMENT && (
              <div>
                <h6>Files</h6>
                {conversationDetails.all_files ? (
                  'All Files'
                ) : (
                  <ul className={classnames(styles.files)}>
                    {conversationDetails.file_names?.map((name, ix) => (
                      <li key={ix}>{name}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
          <div className={styles.conversation}>
            <AIConversationPane
              aiSearch={conversationDetails as AIConversation}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AISearchDetail;
